import React from "react";
import ContentLayout from "../../component/ContentLayout";

const SocialImpact = () => {
    return (
        <ContentLayout
            className={"items-start rounded-3xl m-2 gap-6 overflow-y-scroll"}
        >
            <p className={"text-3xl font-bold text-primaryText"}>Social Impact Media/Press</p>
        </ContentLayout>
    );
};

export default SocialImpact;
